module.exports = __webpack_public_path__ + "img/settings.48c91bfd.svg";